import(/* webpackMode: "eager" */ "/vercel/path0/src/modules/leaderboard/leaderboard.tsx")